/** Keep in sync with repo root VERSION (also baked into web-server/api health). */
export const APP_VERSION = "0.1.106" as const;
